import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {IndexComponent} from './index/index.component';
import {EditComponent as UserEditComponent} from './edit/edit.component';
import {UserService} from '../../../services/api/administration/user.service';

export const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.USER_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.users.index.breadcrumb',
          translate: true,
          route: '/administration/users'
        },
      ]
    }
  },
  {
    path: ':id',
    component: UserEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      user: UserService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.USER_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.users.index.breadcrumb',
          translate: true,
          route: '/administration/users'
        },
        {dynamic: true, dataKey: 'user.name', route: '/administration/users/:id'},
        {label: 'authenticated.administration.users.edit.breadcrumb', translate: true,},
      ]
    }
  }
];
